import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import Header from "../header/Header";
import Sidebar from "../sidebar/Sidebar";
import AccessHistoryService from "./AccessHistoryService";
import { useHistory } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { clearAuthenticatedSession } from "../../configurations/authSession";
import { useTheme } from "../../configurations/themeProvider";

const useStyles = makeStyles(() => ({
    desktop: {
        display: "flex",
    },
}));

const Layout = React.forwardRef((props, ref) => {
    const classes = useStyles();
    const history = useHistory();
    const { resetClientTheme } = useTheme();

    useEffect(() => {
        const pageName = window.location.pathname.replace("/UI", "");
        const userId = sessionStorage.getItem("userId");
        const data = { pageName, userId };

        AccessHistoryService.validateAndRegister(data).catch((e) => {
            if (e.request.status + "" === "401") {
                history.push("/login");
                clearAuthenticatedSession();
                resetClientTheme();
            } else {
                history.push("/home");
            }
        });
    }, [history, resetClientTheme]);

    const [isPrinting, setIsPrinting] = useState(false);
    const componentRef = useRef();

    const makePrint = useReactToPrint({
        content: () => componentRef.current,
        onAfterPrint: () => setIsPrinting(false),
    });

    useEffect(() => {
        if (isPrinting) {
            makePrint();
        }
    }, [isPrinting, makePrint]);

    return (
        <div className={classes.desktop} ref={ref}>
            <Grid item style={{ marginRight: 60 }}>
                <div style={!props.print ? { display: "block" } : { display: "none" }}>
                    <Sidebar />
                </div>
            </Grid>
            <Grid container direction="column">
                <div style={!props.print ? { display: "block" } : { display: "none" }}>
                    <Header />
                </div>
                <div style={{ marginLeft: "25px", marginRight: "15px" }}>
                    {props.children}
                </div>
            </Grid>
        </div>
    );
});

Layout.propTypes = {
    fields: PropTypes.node,
};

export default Layout;